<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTOR' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPalabraClave"
              name="nomPalabraClave">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORCODIGO' | translate }}</label>
                <div *ngIf="!tiposProductores">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="6"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORCODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="tiposProductores && tiposProductores.idTipoProductor">
                  <label class="falso-combo-texto">{{tiposProductores.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORNOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="50"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORNOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>

              </div>
            </div>

          </div>
          <div class="grid form-group">

            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_MONTOMINIMO' | translate }}</label>

                <input type="text" pInputText id="montoMinimo"
                       name="nommontoMinimo"
                       autocomplete="off"
                       formControlName="rangoMinimo"
                       (blur)="validarValor($event, true)"
                       numero-decimal-reactive [maxLength]="14"
                       [decimales]="6" [minimo]="0" [entero]="7">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoMinimo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="!rangoMontoValido">
                  {{ 'GARANTIASIDONEAS.MSG_ERRORRANGO' | translate }}
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_MONTOMAXIMO' | translate }}</label>
                <input type="text" pInputText id="montoMaximo"
                       name="nommontoMaximo"
                       autocomplete="off"
                       formControlName="rangoMaximo"
                       (blur)="validarValor($event, true)"
                       numero-decimal-reactive [maxLength]="14"
                       [decimales]="6" [minimo]="0" [entero]="7">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoMaximo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && !rangoInvalido">
                  {{ 'GARANTIASIDONEAS.MSG_ERRORRANGOMONTO' | translate }}
                </div>

              </div>
            </div>

          </div>


          <div class="grid form-group">
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
                <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
              </div>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar( true)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>


      </p-panel>
    </div>
  </div>
</div>




<p-confirmDialog #cd key="tipo-productores">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
